var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.55 19.919c-.97-4.54.016-8.263 2.385-10.603 2.37-2.34 6.14-3.314 10.736-2.356 1.94 9.063-3.944 14.875-13.121 12.959z",
    fill: "#61C16C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.025 9.536c-3.404-.189-6.219.817-8.127 2.702-1.909 1.869-2.911 4.633-2.736 8.01a15.856 15.856 0 0 1-2.624-.345c-.97-4.54.032-8.262 2.385-10.603 2.386-2.356 6.14-3.314 10.752-2.356.207.911.318 1.76.35 2.592z",
    fill: "#48A34B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.026 20.405c-4.517-1.303-7.363-3.91-8.334-7.084-.97-3.173-.063-6.91 2.959-10.46 9.018 2.575 11.42 10.445 5.375 17.544z",
    fill: "#61C16C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.743 19.494c-.222.299-.477.597-.731.911-4.501-1.288-7.364-3.91-8.334-7.084-.986-3.173-.064-6.91 2.958-10.46.875.25 1.686.549 2.433.91-2.449 3.283-3.133 6.644-2.242 9.566.81 2.545 2.815 4.744 5.916 6.157z",
    fill: "#48A34B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.362 22.919v6.063c0 7.021-5.758 12.707-12.867 12.707H13.513C6.403 41.69.646 36.003.646 28.982v-6.063c0-1.681 1.384-3.032 3.07-3.032h42.576c1.702 0 3.07 1.35 3.07 3.032z",
    fill: "#B5B5B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.38 22.919v6.063c0 7.021-5.758 12.723-12.884 12.723H13.53a12.958 12.958 0 0 1-9.956-4.634c1.05.283 2.131.409 3.277.409h22.966c7.109 0 12.882-5.687 12.882-12.724v-4.869h3.595c1.686 0 3.085 1.35 3.085 3.032z",
    fill: "#A3A1A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.673 41.69v2.826c0 1.304-1.065 2.357-2.385 2.357H15.743c-1.32 0-2.386-1.053-2.386-2.357V41.69h23.316z",
    fill: "#B5B5B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.67 41.69v2.842c0 1.288-1.066 2.356-2.387 2.356H15.74a2.366 2.366 0 0 1-2.37-2.167h18.465c1.304 0 2.386-1.053 2.386-2.356v-.66h2.45v-.016z",
    fill: "#A3A1A1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.247 19.887h-11.15l-.063-.11c-1.13-2.136-3.117-3.66-5.407-4.508a7.702 7.702 0 0 1-3.69-2.874A7.519 7.519 0 0 1 4.02 1.886C7.535-.438 12.307.504 14.66 3.96a7.546 7.546 0 0 1 1.289 4.46c-.08 2.42.588 4.791 2.179 6.645l4.119 4.822z",
    fill: "#E2B09C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.247 19.887h-5.312l-1.686-1.98c-1.575-1.853-2.259-4.24-2.18-6.643.048-1.54-.35-3.095-1.288-4.461-2.258-3.299-6.663-4.304-10.13-2.404a7.665 7.665 0 0 1 2.37-2.528C7.534-.454 12.29.488 14.66 3.944a7.562 7.562 0 0 1 1.287 4.477c-.079 2.418.605 4.806 2.18 6.644l4.119 4.822z",
    fill: "#D8957B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.698 29.422v2.748c0 .519-.43.943-.954.943H27.37v4.32c0 .518-.43.942-.954.942h-2.8a.951.951 0 0 1-.954-.943v-4.32h-4.374a.951.951 0 0 1-.954-.942v-2.748c0-.519.43-.943.954-.943h4.374v-4.32c0-.518.43-.942.954-.942H26.4c.524 0 .954.424.954.943v4.32h4.373c.541 0 .97.407.97.942z",
    fill: "#F79A64"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.354 24.144v4.32h-2.068v-4.32a.951.951 0 0 0-.954-.943H26.4c.524 0 .954.424.954.943zm-2.068 8.969h2.068v4.32c0 .518-.43.942-.954.942h-2.068a.951.951 0 0 0 .954-.943v-4.32zm7.412-3.707v2.733c0 .534-.43.958-.954.958h-2.068a.954.954 0 0 0 .954-.958v-2.733a.951.951 0 0 0-.954-.943h2.068c.524.016.954.44.954.943z",
    fill: "#F27F3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.3c52454e24dcd83fc4baa88e2476c5b3.svg";
export { ForwardRef as ReactComponent };